import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesComponent } from './pages.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { ComponentsModule } from '../components/components.module';
import { NotauthorizedComponent } from './notauthorized/notauthorized.component';
import { RespuestaComponent } from './respuesta/respuesta.component';
import { HomeComponent } from './home/home.component';
import { PreguntasComponent } from './preguntas/preguntas.component';
import { TemasComponent } from './temas/temas.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BurbujaComponent } from './burbuja/burbuja.component';
import { TemaComponent } from './tema/tema.component';
import { PreguntaComponent } from './pregunta/pregunta.component';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { VideotutorialComponent } from './videotutorial/videotutorial.component';
import { LinkComponent } from './link/link.component';
import { ResultadosBusquedaComponent } from './resultados-busqueda/resultados-busqueda.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PipeModule } from '../pipes/pipe.module';
import { TempoLoginComponent } from './tempo-login/tempo-login.component';
import { NgxHighlightWordsModule } from "ngx-highlight-words";

@NgModule({
  declarations: [
    PagesComponent,
    NotauthorizedComponent,
    RespuestaComponent,
    HomeComponent,
    PreguntasComponent,
    TemasComponent,
    BurbujaComponent,
    TemaComponent,
    PreguntaComponent,
    VideotutorialComponent,
    LinkComponent,
    ResultadosBusquedaComponent,
    TempoLoginComponent,
    NopagefoundComponent
  ],
  imports: [
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'X-XSRF-COOKIE',
      headerName: 'X-XSRF-TOKEN',
    }),
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    PipeModule,
    DragDropModule,
    NgxHighlightWordsModule
  ],
  exports:[
    PagesComponent
  ]

})
export class PagesModule { }
